// extracted by mini-css-extract-plugin
export var list = "OurTeamList-module--list--1zYNH";